export default __webpack_public_path__ + "static/media/react-developer.21bbe6c0.png";